<mat-toolbar class="subtitulo">Planejamento das Atividades</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>

                <mat-icon>search</mat-icon>
                <mat-form-field fxFlex="50%" >
                    <mat-label>Selecione uma unidade</mat-label>
                    <mat-select [(ngModel)]="unidadeSelecionada" name="unidade" (selectionChange)="carregarTurmas()">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let m of unidadesComboCadastro" [value]="m">
                            {{m.nomeUnidade}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>


                <mat-icon>search</mat-icon>
                <mat-form-field fxFlex="50%">
                    <mat-label>Selecione uma turma</mat-label>
                    <mat-select [(ngModel)]="turmaSelecionada" name="turma" (selectionChange)="carregarOficinas()">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let m of turmasCombo" [value]="m">
                            {{m.descricao}} - {{turnos.getDescricao(m.turno)}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-icon>search</mat-icon>
                <mat-form-field fxFlex="50%">
                    <mat-label>Selecione uma Atividade</mat-label>
                    <mat-select [(ngModel)]="oficinaSelecionada" name="oficina" (selectionChange)="carregarAcoes()">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let m of oficinasCombo" [value]="m">
                            {{m.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>


                <mat-icon>search</mat-icon>
                <mat-form-field fxFlex="50%">
                    <mat-label>Selecione uma ação</mat-label>
                    <mat-select [(ngModel)]="acaoSelecionada" name="atividade">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of acoesAtividadeCombo" [value]="d">
                            {{d.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>


                <mat-icon>search</mat-icon>
                <mat-form-field fxFlex="50%">
                    <mat-label>Selecione o status da análise</mat-label>
                    <mat-select [(ngModel)]="statusAnaliseSelecionado" name="statusAnalise">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of listaStatusAnalise" [value]="d.id">
                            {{d.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

            </div>
                

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px" multiTemplateDataRows>

            <ng-container matColumnDef="expand">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                <mat-icon style="cursor: pointer;">{{expandedElement === element ? 'expand_less' : 'expand_more'}}</mat-icon>
                </td>
            </ng-container>

              <ng-container matColumnDef="atividade">
                <th mat-header-cell *matHeaderCellDef> Atividade </th>
                <td mat-cell *matCellDef="let element"> {{element.atividade.descricao}} </td>
              </ng-container> 
              
              <ng-container matColumnDef="periodo">
                <th mat-header-cell *matHeaderCellDef> Período: </th>
                <td mat-cell *matCellDef="let element"> {{mascaraPeriodo(element.numeroGrupo)}} </td>
              </ng-container>
              
              <ng-container matColumnDef="responsavelAnalise">
                <th mat-header-cell *matHeaderCellDef> Responsável Análise: </th>
                <td mat-cell *matCellDef="let element"> {{element.usuarioAnalise?.pessoaFisica?.nome}} </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status Análise </th>
                <td mat-cell *matCellDef="let element">
                    {{!element.statusEnvioAnalise ? 'Aguardando' : 
                        element.statusAnalise === 'A' ? 'Aprovado' : 
                            element.statusAnalise === 'R' ? 'Reprovado' : 'Em Análise' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element" (click)="toggleRow(element)">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>
            
            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div *ngIf="expandedElement === element" class="expanderDatatable">
                        <table class="subDatatable">
                            <tr>
                                <th>Data Previsão</th>
                                <th>Local Execução</th>
                                <th>Descrição</th>
                            </tr>
                            <tr *ngFor="let acao of element.acoes">
                                <td>{{acao.dataPrevisaoInicio | dataSimples}}</td>
                                <td>{{acao.localExecucao === 'I' ? 'Interno' : acao.localExecucao === 'E' ? 'Externo' : ''}}</td>
                                <td>{{acao.descricao}}</td>
                            </tr>
                        </table>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row" (click)="toggleRow(row)"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="expanderDatatable-row" [class.expanderDatatable-row-show]="expandedElement === row"></tr>

        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova meta" mat-fab color="primary"
                    [routerLink]="['/acoesoficinas/cadastrar']" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>

